<script setup>
/* global axios */
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { copy } from './copy';

const route = useRoute();
const reports = ref([]);
let timer;
let disposed = false;
async function load() {
  const account = route.params.accountId;
  try {
    const { data } = await axios.get(
      `/api/v1/accounts/${account}/aceleres/attendances/operations`
    );
    if (!disposed && account === route.params.accountId)
      reports.value = data.payload.filter(
        item =>
          item.kind === 'report' &&
          item.state === 'completed' &&
          item.total > 5000
      );
  } catch {
    reports.value = [];
  }
  if (!disposed) timer = setTimeout(load, 30000);
}
onMounted(load);
watch(
  () => route.params.accountId,
  () => {
    clearTimeout(timer);
    reports.value = [];
    load();
  }
);
onBeforeUnmount(() => {
  disposed = true;
  clearTimeout(timer);
});
</script>

<template>
  <section
    v-if="reports.length"
    class="attendances-notification-center mx-4 mb-4 rounded-2xl border border-n-weak bg-n-solid-1 p-4"
  >
    <h2
      class="attendances-notification-center-title mb-3 text-sm font-semibold text-n-slate-12"
    >
      {{ copy.reports }}
    </h2>
    <RouterLink
      v-for="report in reports"
      :key="report.id"
      :to="{
        name: 'aceleres_attendances',
        params: { accountId: route.params.accountId },
        query: { report: report.id },
      }"
      class="attendances-center-notification mb-2 flex items-center gap-3 rounded-xl border border-n-weak p-3 text-n-slate-12"
    >
      <Icon
        icon="i-lucide-file-spreadsheet"
        class="attendances-center-notification-icon size-5"
      />
      <span class="attendances-center-notification-copy flex-1"
        ><strong class="attendances-center-notification-title block text-sm">{{
          copy.reportReady
        }}</strong
        ><span
          class="attendances-center-notification-details text-xs text-n-slate-11"
          >{{ report.filename }} · {{ report.total }} {{ copy.lines }}</span
        ></span
      >
      <span
        v-if="!report.notification_read"
        class="attendances-center-notification-unread size-2 rounded-full bg-emerald-500"
      />
      <Icon
        icon="i-lucide-chevron-right"
        class="attendances-center-notification-chevron"
      />
    </RouterLink>
  </section>
</template>
